export default __webpack_public_path__ + "static/media/Group image.2b2cc2e5.png";